import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { Button } from '@mui/material';
import classnames from 'classnames';
import HTMLReactParser from 'html-react-parser';

import { useButton, withWidget } from '@ezbobdev/ui-commons';

const MaterialButton = (props) => {
  const {
    className,
    children,
    variant,
    disabled,
    color,
    disableElevation,
    shouldDisableRipple,
    fullWidth,
    onButtonClick,
    textUnderline,
    href,
    size,
    startIcon,
    ...rest
  } = useButton(props, MaterialButton.displayName);

  return useMemo(
    () => (
      <Button
        {...rest}
        className={classnames(MaterialButton.displayName, className)}
        onClick={onButtonClick}
        variant={variant}
        color={color}
        disabled={disabled}
        disableElevation={disableElevation}
        disableRipple={shouldDisableRipple}
        fullWidth={fullWidth}
        href={href}
        size={size}
        startIcon={startIcon}
        {...props.MUIButtonProps}
      >
        {typeof children === 'string' ? HTMLReactParser(children) : children}
      </Button>
    ),
    [
      variant,
      disabled,
      color,
      disableElevation,
      fullWidth,
      onButtonClick,
      textUnderline,
      href,
      size,
      startIcon,
      props.MUIButtonProps,
    ],
  );
};

MaterialButton.propTypes = {
  name: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['contained', 'outlined', 'text', 'overline', 'icon']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'success', 'error', 'info', 'warning', 'grey']),
  href: PropTypes.string,
  fullWidth: PropTypes.bool,
  startIcon: PropTypes.node,
  disabled: PropTypes.bool,
  disableElevation: PropTypes.bool,
  onClick: PropTypes.func,
  MUIButtonProps: PropTypes.object,
};

MaterialButton.displayName = 'MaterialButton';

export default React.memo(withWidget(MaterialButton));
